namespace ui
{
	export namespace Form
	{

		export interface ILabelledSliderDescriptor
			extends IBasicInputDescriptor
		{
			value?:			Array<string|number>;
			sentinal?:	string;
		}

		export class LabelledSlider
			extends BasicInputField<HTMLElement, ILabelledSliderDescriptor>
		{

			/**
			 * Shadowing Default property to only except numbers.
			 */
			public readonly	Default: number;

			private		m_Text: JQuery<HTMLSpanElement>;
			private		m_Input: Slider;
			private		m_Range: Array<string|number>;
			private		m_ItemCount: number;
			private		fn_Translater: (text: string) => string;

			/**
			 *
			 * @param descriptor The LabelledSlider specific descriptor for initialization.
			 * @param display The callback function to translate a given string by the slider range values.
			 * @param value The default value for the slider.
			 */
			public constructor(
				descriptor: ILabelledSliderDescriptor,
				display: (text: string) => string = ( text: string ) => text
			)
			{
				super( 'labelled-slider', descriptor, InputValueTypes.NUMBER );

				this.m_Text					= ui.$$.label();
				this.m_Input				= new Slider( -1, { min:	-1, max:	(descriptor.value || []).length - 1, step:	1 } );
				this.Default				= -1;
				this.fn_Translater	= display;
				this.m_Range				= new Array();
				this.m_ItemCount		= 0;

				this.m_Input.Initialize();
				this.m_Input.Input().appendTo( this.m_Root );

				this.m_Root.append( this.m_Text );

				this.m_Input.value( -1 );

				this.m_Input
					.on( 'click', () => { this.showTextByValue(); } )
					.on( 'input', () => { this.showTextByValue(); } )
					.on( 'change', () => { this.showTextByValue(); } );
			}

			public rebuild( root: ui.base.BaseHTMLElement<HTMLElement>|JQuery<HTMLElement> ): LabelledSlider
			{
				super.rebuild( root );

				this.m_Input.Input().removeClass( 'form-control' );

				this.showTextByValue();

				return this;
			}

			public Initialize(): void
			{
				super.Initialize();

				this.AddItem( this.Descriptor.sentinal || '' );

				( this.Descriptor.value || [] ).forEach( ( value ) => this.AddItem( value ) );

				if ( this.Descriptor.control )
				{
					this.m_Text.addClass( 'form-control' );
				}

				this.m_Root.removeClass( 'form-control' );
				this.m_Base.removeClass( 'form-control' );
			}

			public val(): number|null
			{
				const val = this.m_Input.val();

				return val;
			}

			public AddItem( item: string|number )
			{
				this.m_Range.push( item );
				++this.m_ItemCount;

				this.m_Input.attr( 'max', this.m_ItemCount - 2 );
			}

			public value( value: number|null ): LabelledSlider
			{
				const val = value === null ? -1 : value;

				this.m_Input.value( val );

				this.showTextByValue();

				this.m_StaticAlt.empty().append( this.m_Range[ ( val === null ? -1 : val ) + 1 ] as string );

				return this;
			}

			public reset(): void
			{
				this.value( this.Default );
			}

			private showTextByValue(): void
			{
				const val = this.val();

				this.m_Text.text( this.fn_Translater( this.m_Range[ ( val === null ? -1 : val ) + 1 ] as string ) );
			}

		}

	}
}
